var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"center","flex-direction":"column"},style:(_vm.size),attrs:{"id":"ver-bar"}},[_c('e-charts',{staticStyle:{"margin-top":"20px"},attrs:{"size":_vm.size,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }